export class AgendaGenerator {
    agenda: number;
    sesiones: number;
    tracks: number;
    algoritmo: string;
  }
